/* Built In Imports */
import dynamic from 'next/dynamic';
/* External Imports */

/* Internal Imports */
/* Components */
import { Box } from '@chakra-ui/react';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';

/* Services */
import { getLocale } from '@shi/Utility/Shared/SharedService';
import { performRequest } from '@utils/microsites/DatoCMSHelperService';
import { getMenuQuery, getQuery } from '@utils/microsites/MOMGqlQueries';

const MomUi = dynamic(() => import('@moms/Ui/MomUi'), {
  loading: () => <div>Loading...</div>,
});
/**
 *
 * @param {Object} pageData
 * @returns
 */
const MomNew = ({ pageData, region, language }: object) => {
  // console.log(pageData, "pagedata")
  return (
    <Box w="100%"
      float="left"
      pos="relative">
      <WrapLayout pageData={pageData}>

        <HeadComponent
          data={pageData?._seoMetaTags || pageData?.seoFields}
          availableLocals={pageData?.availableLocales}
        >
          {' '}
        </HeadComponent>
        <Box w="100%"
          float="left"
          pos="relative">
          {pageData.body.length && (

            <MomUi pageData={pageData} region={region} lang={language} />
          )}
        </Box>
      </WrapLayout>
    </Box>
  );
};
export const getStaticPaths = async () => {
  const eventsLandingPaths = [
    '/in/en/miracle-of-mind',
    '/ca/en/miracle-of-mind',
    '/us/en/miracle-of-mind',
    '/sg/en/miracle-of-mind',
    '/au/en/miracle-of-mind',
    '/uk/en/miracle-of-mind',
    '/my/en/miracle-of-mind',
    '/global/en/miracle-of-mind',
    '/in/hi/miracle-of-mind',
    '/in/ta/miracle-of-mind',
    '/in/te/miracle-of-mind',
    '/global/fr/miracle-of-mind',
    '/global/zh/miracle-of-mind',
    '/global/de/miracle-of-mind',
    '/global/it/miracle-of-mind',
    '/global/es/miracle-of-mind',
    '/global/ru/miracle-of-mind',
  ];

  return {
    paths: eventsLandingPaths,
    fallback: false,
  };
};
export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerMenuData = await performRequest(
    getMenuQuery('mommainmenu', getLocale(region, language)),
    'mommainmenu'
  );
  // console.log(getMenuQuery('mommainmenu', getLocale(region, language)), "Index of mom")
  const footerData = await performRequest(
    getMenuQuery('momfooter', getLocale(region, language)),
    'momfooter'
  );
  // console.log(headerMenuData, footerData, 'headerMenuData, footerData');
  const response = await performRequest(
    getQuery('miracle-of-mind', getLocale(region, language))
  );
  // console.log(response, 'respn');
  let pageData = response.allMiracleOfMinds[0] || [];
  // console.log(pageData);
  // let pageData = response?.allShivangaLandingPages;

  pageData = JSON.stringify(pageData).replace(
    /https:\/\/www.datocms-assets.com\//g,
    `${config.staticPath}/d/`
  );
  pageData = JSON?.parse(pageData);

  return {
    props: {
      headerMenuData: headerMenuData || null,
      pageData: pageData || '',
      footerData: footerData || null,
      isPreview: preview ? true : false,
      region: region,
      language: language,
      menuType: 'shivangamainmenu',
    },
  };
};

export default MomNew;
